module.exports = __webpack_public_path__ + "static/img/red-panda-6-arms.17fe49c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/benches/red-panda-6-arms.jpg
// module id = 540
// module chunks = 0